import apiClient from '@/lib/api/client'

export type CsatQuestion = {
  id?: number
  question_text: string
  question_type: 'rating' | 'text'
  sort_order: number
  required: boolean
}

export type CsatSurveyPayload = {
  token: string
  survey_name: string
  survey_description?: string | null
  ticket_number?: string | null
  responded: boolean
  expired: boolean
  questions: CsatQuestion[]
}

export type CsatAnswerInput = {
  question_id: number
  value: string
}

function unwrapData<T>(payload: unknown): T {
  if (payload != null && typeof payload === 'object' && 'data' in payload) {
    return (payload as { data: T }).data
  }
  return payload as T
}

export async function getCsatSurveyByToken(token: string): Promise<CsatSurveyPayload> {
  const res = await apiClient.get(`/csat/${encodeURIComponent(token)}`)
  return unwrapData<CsatSurveyPayload>(res.data)
}

export async function submitCsatSurvey(token: string, answers: CsatAnswerInput[]): Promise<{ message: string }> {
  const res = await apiClient.post(`/csat/${encodeURIComponent(token)}`, { answers })
  return unwrapData<{ message: string }>(res.data)
}
